import { get, post, del } from '../utils/api';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchSlot1Options = async () => {
  return get(`${API_URL}/trial-booking/slot1-options`, true);
};

export const createTrialHold = async (slot1ScheduleId, slot1DateUK) => {
  return post(
    `${API_URL}/trial-booking/hold`,
    slot1DateUK ? { slot1ScheduleId, slot1DateUK } : { slot1ScheduleId },
    true,
  );
};

// ── Superseded by the one-slot back-to-back flow: slot 2 is derived server-side from the
// hold; there is no slot-2 endpoint any more. ──
//
// export const fetchSlot2Options = async (holdId) => {
//   return get(`${API_URL}/trial-booking/hold/${holdId}/slot2-options`, true);
// };

export const releaseTrialHold = async (holdId) => {
  if (!holdId) return;
  try {
    await del(`${API_URL}/trial-booking/hold/${holdId}`, true);
  } catch (err) {
    // best-effort cleanup; TTL on the hold is the authoritative safety net
  }
};

export const errorCodeFrom = (error) => {
  return error?.response?.data?.code ?? null;
};
